import { api } from '../../api'
import entities from '../../api/entities'
import { endpointSetter } from '../../api/utils'
import {
  BlocktrainDetail,
  BlockTrainFilePayload,
  BlocktrainStatusCount,
  Depot,
  Filters,
  GetAllBlocktrainsByFiltersResponse,
  UpdateBlocktrainStatusPayload,
} from '../../types'

interface GetByIdResponse {
  blockTrain: BlocktrainDetail
}

const entity = entities.blocktrain
const endpoint = `/${entity}`
const idEnpointSetter = endpointSetter(endpoint)
const bodyProperty = entity

const exportAll = async (id: string | undefined) => {
  const response = await api.get<{
    blockTrain: BlocktrainDetail & { destination: Depot }
  }>(`/blocktrain/export/${id}`)
  return response.data.blockTrain
}

const getAllByFilters = async ({ filters }: { filters?: Filters }) => {
  const response = await api.get<GetAllBlocktrainsByFiltersResponse>(endpoint, {
    params: filters,
  })

  return response.data.blockTrains
}
const getById = async (id: number | string) => {
  const response = await api.get<GetByIdResponse>(idEnpointSetter(id))

  return response.data.blockTrain
}

const post = async (payload: any) => {
  const response = await api.post<any>(endpoint, { [bodyProperty]: payload })

  return response.data.result
}
const put = async (id: number | string, payload: any) => {
  const response = await api.put<any>(idEnpointSetter(id), payload)

  return response.data.result
}

const uploadBlockTrainFile = async (payload: BlockTrainFilePayload) => {
  const formData = new FormData()
  if (payload.blockTrainFile instanceof File) {
    formData.append('ticketFile', payload.blockTrainFile)
  } else {
    throw new Error('blockTrainFile is not a File object')
  }
  if (payload.fileTypeId !== undefined) {
    formData.append('fileTypeId', payload.fileTypeId.toString())
  } else {
    throw new Error('fileTypeId is required')
  }

  const response = await api.post(`${endpoint}/${payload.blockTrainId}/add-file`, formData)
  return response.data
}

const getStatusCounts = async () => {
  const response = await api.get<BlocktrainStatusCount>(`${endpoint}/status-counts`)

  return response.data
}

const statusUpdate = async ({ id, ...payload }: UpdateBlocktrainStatusPayload) => {
  const response = await api.put<any>(idEnpointSetter(id, 'status'), payload)

  return response.data.result
}

const updateStatus = async (id: number | string, newStatus: string) => {
  const response = await api.patch(idEnpointSetter(id, 'status'), { status: newStatus })
  return response.data
}

const BlocktrainApi = {
  getAllByFilters,
  getById,
  post,
  put,
  uploadBlockTrainFile,
  getStatusCounts,
  statusUpdate,
  updateStatus,
  exportAll,
}

export default BlocktrainApi
